var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",style:(_vm.getStyles()),attrs:{"src":_vm.encodedImage ? _vm.src : require(`@/${_vm.src}`)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }